angular.injector(['ng', 'translate']).invoke([  'translationLoader',  function (translationLoader) {    translationLoader.addTranslationPartial({
  "MEETING_TIME": {
    "FLEXIBLE": "Flexible",
    "EARLIER": "Earlier (from 6am)",
    "MORNING": "Morning (from 9am)",
    "NOON": "Noon (from 12pm)",
    "AFTERNOON": "Afternoon (from 3pm)",
    "EVENING": "Evening (from 6pm)",
    "NIGHT": "Night (from 9pm)"
  }
}
);  }]);


//////////////////
// WEBPACK FOOTER
// ./webpack_loaders/nls.js!./app/src/constants/meeting_time_options.json
// module id = 120
// module chunks = 24